import { lazy } from 'react'

export const SvgComponents = {
  GiddyUpLogo: lazy(() => import('./GiddyUpLogo')),
  GiddyUpLogoCompact: lazy(() => import('./GiddyUpLogoCompact')),
  GiddyUpG: lazy(() => import('./GiddyUpG')),
  GooglePay: lazy(() => import('./GooglePay')),
  SkyRacing: lazy(() => import('./SkyRacing')),
  TABLogo: lazy(() => import('./TABLogo')),
  PayIDLogo: lazy(() => import('./PayIDLogo')),
  TABtouchLogo: lazy(() => import('./TABtouchLogo')),
  TABtouchBrandLogo: lazy(() => import('./TABtouchBrandLogo')),
  BetLoopHeaderLogo: lazy(() => import('./BetLoopHeaderLogo')),
}
